import { DynamicFormModal } from '@/shared/components/dynamic-form/DynamicFormModal/DynamicFormModal';
import { type ModalComponentProps } from '@/shared/components/Modals/modal-registry/modal-registry.types';

import { type TierLimitDraft } from '../../utils/tier-limit-fields/tier-limit-fields.util';

import { useTierLimitEditorModalLogic } from './useTierLimitEditorModalLogic';

/**
 * One tier's numeric levers.
 *
 * Presentation only; what the boxes are seeded from, what each sentence says,
 * and what a save writes are all in `useTierLimitEditorModalLogic` (U5).
 */
export function TierLimitEditorModal({ open, onCancel, modalData }: ModalComponentProps) {
  const view = useTierLimitEditorModalLogic({
    tier: typeof modalData?.['tier'] === 'string' ? modalData['tier'] : '',
    onDone: onCancel,
  });

  return (
    <DynamicFormModal<TierLimitDraft>
      isOpen={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) onCancel();
      }}
      title={view.title}
      description={
        view.genderNotice === null ? view.description : `${view.description} ${view.genderNotice}`
      }
      size="md"
      // Withheld until the overrides arrive: RHF reads `defaultValues` once, and
      // a form mounted before the load would open on an empty box and offer to
      // save it as "this tier overrides nothing".
      isLoading={view.isLoading}
      fields={view.fields}
      schema={view.schema}
      initialValues={view.initialValues}
      submitLabel={view.saveLabel}
      onCancel={onCancel}
      onSubmit={view.submit}
    />
  );
}
